module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_197d4ac2.91aa16cb.eot";